export function mergeUrl(relativePath: string, basePath: string | undefined = window.config.BASE_PATH): string {
	// Default to empty string if basePath is undefined or "/"
	const base = !basePath || basePath === '/' ? '' : basePath;
	// Join and collapse multiple slashes to one
	return (base + '/' + relativePath).replace(/\/{2,}/g, '/');
}
